import { z } from 'zod';

export const TimecardEntrySchema = z.object({
  id: z.string().uuid(),
  userId: z.string().uuid(),
  workOrderId: z.string().uuid().nullable(),
  date: z.string().date(), // YYYY-MM-DD
  hours: z.number().min(0).max(24),
  operationDescription: z.string(),
  isOvertime: z.boolean(),
  approvedBy: z.string().uuid().nullable(),
  approvedAt: z.string().datetime().nullable(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export type TimecardEntry = z.infer<typeof TimecardEntrySchema>;

export const CreateTimecardEntrySchema = TimecardEntrySchema.omit({
  id: true,
  approvedBy: true,
  approvedAt: true,
  createdAt: true,
  updatedAt: true,
});

export type CreateTimecardEntry = z.infer<typeof CreateTimecardEntrySchema>;
